import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { profileCandidateAPI } from '../../../../api'
import { userData } from 'features/user/store'
import {
  PROFILE_STUDENT_RESUME_REMOVE_REQUEST,
  PROFILE_STUDENT_RESUME_REMOVE_SUCCESS,
  PROFILE_STUDENT_RESUME_REMOVE_FAILED,
} from './actionTypes'

export const profileStudentResumeRemovePA = createPromiseAction(
  PROFILE_STUDENT_RESUME_REMOVE_REQUEST,
  PROFILE_STUDENT_RESUME_REMOVE_SUCCESS,
  PROFILE_STUDENT_RESUME_REMOVE_FAILED
)()

function* remove(action) {
  try {
    const response = yield call(profileCandidateAPI.deleteResume)
    const { data } = response

    yield put(profileStudentResumeRemovePA.success({}))

    yield put(userData.updateStudentProfile({ resume: null }))

    resolvePromiseAction(action, {})
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* removeSaga() {
  yield takeEvery(profileStudentResumeRemovePA.request, remove)
}
